module.exports = __webpack_public_path__ + "img/orbit-claim-modal-background.93f42a8c.png";